<script>
    import {role} from "../stores";

    function logout() {
        firebase.auth().signOut();
    }

    let admin = false;

    role.subscribe(value => admin = value === "admin");
</script>

<aside class="left-sidebar">
    <div class="scroll-sidebar">
        <nav class="sidebar-nav">
            <ul id="sidebarnav">
                <li><a class="waves-effect waves-dark" href="#/equipment" aria-expanded="false"><i
                        class="mdi mdi-gauge"></i><span class="hide-menu">Equipment Summary </span></a></li>
                <li><a class="waves-effect waves-dark" href="#/alerts" aria-expanded="false"><i
                        class="mdi mdi-bell"></i><span class="hide-menu">My alerts </span></a></li>
                {#if admin}
                    <li>
                        <a class="waves-effect waves-dark" href="#/users" aria-expanded="false">
                            <i class="mdi mdi-account"></i>
                            <span class="hide-menu">Users</span>
                        </a>
                    </li>
                    <li>
                        <a class="waves-effect waves-dark" href="#/productTypes" aria-expanded="false">
                            <i class="mdi mdi-invert-colors"></i>
                            <span class="hide-menu">Product types</span>
                        </a>
                    </li>
                    <li>
                        <a class="waves-effect waves-dark" href="#/organizations" aria-expanded="false">
                            <i class="mdi mdi-briefcase"></i>
                            <span class="hide-menu">Organizations</span>
                        </a>
                    </li>
                {/if}
            </ul>
        </nav>
    </div>

    <div class="sidebar-footer">
        <!--        <a href="#" class="link" data-toggle="tooltip" title="Settings"><i class="ti-settings"></i></a>-->
        <a on:click={logout} class="link" data-toggle="tooltip" title="Logout"><i class="mdi mdi-power"></i></a>
    </div>
</aside>